import {
  SET_BREADCRUMB
} from './types';
 
const setBreadcrumb = (currentScreen:any) => ({
  type: SET_BREADCRUMB,
  currentScreen
})

export {
  setBreadcrumb
};
  